/** Logical UI surfaces for the `surface` custom dimension (compare with web app `surfaces.ts`). */
export const TelemetrySurface = {
  app: "app",
  /** Task pane title / header updates */
  page: "page",
  authentication: "authentication",
  organisation: "organisation",
  receivablesTable: "receivables_table",
  searchReceivables: "search_receivables",
  searchPayables: "search_payables",
  payableList: "payable_list",
  groupedChase: "grouped_chase",
  activities: "activities",
  dashboard: "dashboard",
  receivablesHub: "receivables_hub",
  /** Assign / reassign email from footer (activities, payables, receivables, etc.) */
  emailAssignment: "email_assignment",
} as const;

export type TelemetrySurfaceValue = (typeof TelemetrySurface)[keyof typeof TelemetrySurface];
